var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Kenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.716,17H5.284c-0.244,0.652-0.453,1.318-0.629,2h38.689C43.169,18.318,42.959,17.652,42.716,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.344,29H4.656c0.176,0.682,0.385,1.348,0.629,2h37.431C42.959,30.348,43.169,29.682,43.344,29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M44,24c0-1.73-0.243-3.399-0.656-5H4.656C4.243,20.601,4,22.27,4,24s0.243,3.399,0.656,5h38.689 C43.757,27.399,44,25.73,44,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#33691e",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27.687,15.855c-0.301,0.52-0.59,1.043-0.613,1.578l-8.512,15.324l0.875,0.484l8.5-15.301 c0.461-0.285,0.77-0.801,1.07-1.324c0.254-0.441,0.77-1.328,1.211-3.617C28.457,14.527,27.941,15.414,27.687,15.855z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M27.687,15.855c-0.301,0.52-0.59,1.043-0.613,1.578l-8.512,15.324l0.875,0.484l8.5-15.301 c0.461-0.285,0.77-0.801,1.07-1.324c0.254-0.441,0.77-1.328,1.211-3.617C28.457,14.527,27.941,15.414,27.687,15.855z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M20.312,15.855c0.301,0.52,0.59,1.043,0.613,1.578l8.512,15.324l-0.875,0.484l-8.5-15.301 c-0.461-0.285-0.77-0.801-1.07-1.324c-0.254-0.441-0.77-1.328-1.211-3.617C19.543,14.527,20.059,15.414,20.312,15.855z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M27.957,19.5C27.332,18,25.25,15,24,15s-3.332,3-3.957,4.5S19,22.5,19,24s0.418,3,1.043,4.5 S22.75,33,24,33s3.332-3,3.957-4.5S29,25.5,29,24S28.582,21,27.957,19.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24c0,1.477,0.406,2.957,1.016,4.434c0.586-1.48,0.977-2.957,0.977-4.434s-0.391-2.957-0.977-4.434 C19.406,21.043,19,22.523,19,24z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29,24c0,1.477-0.406,2.957-1.016,4.434c-0.586-1.48-0.977-2.957-0.977-4.434s0.391-2.957,0.977-4.434 C28.594,21.043,29,22.523,29,24z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M25,24c0-0.551-0.449-1-1-1s-1,0.449-1,1s0.449,1,1,1S25,24.551,25,24z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,15c0,0-1,1.523-1,4s1,4,1,4s1-1.523,1-4S24,15,24,15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,25c0,0-1,1.523-1,4s1,4,1,4s1-1.523,1-4S24,25,24,25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Kenya);
export default __webpack_public_path__ + "static/media/icons8-kenya.3e43cd35644641c57acdc43168d03cab.svg";
export { ForwardRef as ReactComponent };